import React from 'react';

export type ButtonType = boolean | undefined;

const ButtonContext = React.createContext<ButtonType>(true);

export default ButtonContext;
